export enum EligibilityAction {
    Not_Eligible = 0,
    Eligible = 1,
    Next_Question = 2
}